import { RecaptchaValidator } from "./recaptcha-validator";
import { Component } from '@opten/compiler/metadata/component';

@Component({ className: 'js-recaptcha', observe: true })
export class RecaptchaValidatorComponent {
	constructor(private element: HTMLElement) {
		new RecaptchaValidator(element);
	}
}